import moment from 'moment';

export default function timestamp(value, format = 'HH:mm:ss') {
  return moment(value).format(format);
}
